import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  checkbox: ({ type }) => ({
    composes: `checkbox ${type}`,
  }),
});

export default useStyles;
